import {router} from '../router/index'
import {http} from '../lib/http'
import * as types from '../store/mutation-types'

import store from '../store/index'

// URL and endpoint constants
const API_URL = '/api/';
const LOGIN_URL = API_URL + 'session/login';
const SIGNUP_URL = API_URL + 'session/signup';

export default {

    // Send a request to the login URL and save the returned JWT
    login(context, creds, redirect) {
        context.error = '';

        http.post(LOGIN_URL, creds).then((data) => {
            // localStorage.setItem('id_token', data.id_token);
            localStorage.setItem('access_token', data.token);

            context.$store.dispatch('auth/checkUser').then(() => {
                console.log(redirect)
                // Redirect to a specified route
                if(redirect) {
                    context.$router.push(redirect)
                }
            });



        }).catch((error) => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                context.error = error.response.data
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                context.error = error.request;
            } else {
                // Something happened in setting up the request that triggered an Error
                context.error = error.message;
            }
        });
    },

    signup(context, creds, redirect) {
        context.$http.post(SIGNUP_URL, creds, (data) => {
            // localStorage.setItem('id_token', data.id_token);
            localStorage.setItem('access_token', data.token);

            this.user.authenticated = true;

            if(redirect) {
                context.$router.go(redirect)
            }

        }).error((err) => {
            context.error = err
        })
    },

    // To log out, we just need to remove the token
    logout(context) {
        // localStorage.removeItem('id_token');
        localStorage.removeItem('access_token');
        context.$store.commit('auth/REMOVE_USER_DATA');
        context.$router.push({ name: 'login' });
    },

    fetchUser() {
        return http.get('/api/session/current');
    },
    
    getToken() {
        return localStorage.getItem('access_token');
    },
        
    getUser() {
        console.log(this.user);
        return this.user;
    },
    
    canI(permKey) {
        let bits = permKey.split(':')
        var perm = store.state.auth.permissions;
        return (store.state.auth.is_admin || (perm && perm[bits[0]] && perm[bits[0]][bits[1]]))
    }
}


// WEBPACK FOOTER //
// ./src/auth/index.js